import NoAllotmentCount from './NoAllotmentCount'

export default NoAllotmentCount
